module.exports = __webpack_public_path__ + "static/needle_blight-7ef9d2a1c08224c77aa60800a51d003b.jpg";